package com.tixforgigs.common.ui.pages.login

import com.tixforgigs.apax.models.UpdatePasswordRequest
import com.tixforgigs.common.core.enums.MandarinInputType
import com.tixforgigs.common.core.enums.View
import com.tixforgigs.common.core.extensions.RoutingUtil.AppScope
import com.tixforgigs.common.core.extensions.RoutingUtil.routing
import com.tixforgigs.common.core.extensions.navigateTo
import com.tixforgigs.common.core.interfaces.StorefrontPage
import com.tixforgigs.common.core.models.ui.InputState
import com.tixforgigs.common.core.util.LocalizationUtil.currentTranslationLocale
import com.tixforgigs.common.core.util.TrackerUtil.pageView
import com.tixforgigs.common.http.ApiPostPath
import com.tixforgigs.common.http.HttpClient.apiV4Post
import com.tixforgigs.common.ui.components.grid.gridContainer
import com.tixforgigs.common.ui.components.mandarin.mandarinFilledButton
import com.tixforgigs.common.ui.components.mandarin.mandarinInput
import com.tixforgigs.common.ui.components.mandarin.mandarinTitle
import com.tixforgigs.common.ui.components.root.defaultTemplate
import com.tixforgigs.tarami.GlobalMessage.buttonTextResetPassword
import com.tixforgigs.tarami.GlobalMessage.titlePasswordReset
import de.comahe.i18n4k.language
import io.kvision.core.JustifyItems
import io.kvision.material.ExperimentalMaterialApi
import io.kvision.panel.SimplePanel
import io.kvision.panel.simplePanel
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.SharingStarted
import kotlinx.coroutines.flow.map
import kotlinx.coroutines.flow.stateIn
import kotlinx.coroutines.launch

@OptIn(ExperimentalMaterialApi::class)
class ResetPasswordView(
  val token: String
) : SimplePanel(className = "xm-page xm-page-auth-reset-password"), StorefrontPage {

  override val VIEW: View get() = View.RESET_PASSWORD


  val mPasswordInput = MutableStateFlow(InputState("", false))

  init {
    AppScope.launch {
      pageView()
    }

    defaultTemplate {
      simplePanel(className = "xm-body") {

        gridContainer {
          gridItem(12) {
            mandarinTitle(titlePasswordReset())
          }
          gridItem(12) {
            mandarinInput(state = mPasswordInput, inputType = MandarinInputType.PASSWORD)
          }
          gridItem(12, horizontalAlign = JustifyItems.END) {
            mandarinFilledButton(
              title = buttonTextResetPassword(),
              isEnabled = mPasswordInput.map { it.isValid }
                .stateIn(AppScope, SharingStarted.Eagerly, mPasswordInput.value.isValid)
            ) {
              apiV4Post<Unit>(
                type = ApiPostPath.AccountPasswordUpdate(
                  body = UpdatePasswordRequest(
                    password = mPasswordInput.value.inputValue,
                    locale = currentTranslationLocale.value.language,
                    resetToken = token
                  )
                )
              )?.let {
                routing.navigateTo(View.LOGIN)
              }
            }
          }
        }
      }
    }
  }

}
